//components
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Alert } from 'reactstrap';
import InvitationHandlerAction from "./InvitationHandlerAction";

//libraries / actions/ constants/ utils
import { Strings } from "../../Resources/Strings/i18n";
import { PATHS } from "./../../Constants";
import { OperationStatus } from "../../Communication/Constants";
import Spinner from "../Spinner/Spinner";
import CommonUtils from "../../Utils/CommonUtils";
import Button from "@material-ui/core/Button";


//resources / images
import AllWellLogoImg from "../../Resources/Images/img_logo.png";
import LoginBannerImg from "../../Resources/Images/img_login.png";
import './InvitationHandler.scss'
//stylings
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";

class InvitationHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            spinner: false,
            showDashboard: false,
            userid: "-1",
            accessToken: "-1",
            errorMessage: "",
            errorCase: false,
        };
        this.InvitationHandlerAction = new InvitationHandlerAction();
    }

    getAccessId() {
        const SPLIT_TOKEN = "invitation/"
        const url = window.location.href
        if (url) {
            return url.includes(SPLIT_TOKEN) && url.substr(url.lastIndexOf(SPLIT_TOKEN) + SPLIT_TOKEN.length)
        } else
            return undefined
    }

    componentDidUpdate() {
    }

    componentDidMount() {
        let accessId = this.getAccessId()
        if (accessId) {
            this.setState({ spinner: true });

            this.InvitationHandlerAction.getToken(
                accessId, Intl.DateTimeFormat().resolvedOptions().timeZone, (actionCallback) => {
                    if (actionCallback.status === OperationStatus.SUCCESS) {
                        this.setState({
                            spinner: false,
                            userid: actionCallback.data.data.user_id,
                            accessToken: actionCallback.data.data.access_token,
                            showDashboard: true,
                            showModal: false,
                            errorMessage: "",
                        });
                        this.props.history.push(PATHS.HOME);
                    } 
                    else {
                        this.setState({
                            spinner: false,
                            errorCase: true,
                            errorMessage: actionCallback.error.errorMessage,
                            showModal: false,
                        });
                    }
                }
            );




        } else {
            this.setState({
                errorCase: true,
                errorMessage: Strings("ERROR_INVALID_WEB_TOKEN"),
                showModal: false,
            });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.hideTimeout);
    }
    showModal = () => {
        this.setState({ show: true });
    };
    hideModal = () => {
        this.setState({ show: false });
    };

    renderAlert = () => {
        return (
            <Alert color="danger" className="alertMessage">
                {this.state.errorMessage}
            </Alert>
        );
    };
    render() {
        return (
            <div className="invitation">
                <img className="logo" src={AllWellLogoImg} alt="All Well Logo"></img>

                {this.state.errorCase ? this.renderAlert() : null}

                <div className="banner">
                    <img
                        className="loginBannerImg"
                        src={LoginBannerImg}
                        alt="All Well Login Page"
                    />
                </div>

                <Spinner showModal={this.state.spinner} />{" "}
            </div>
        );
    }
}

// function mapStateToProps(state) {
//     return {
//         inviteInfo: state.inviteInfo,
//         currentUserInfo: state.currentUserInfo,
//     };
// }

function mapStateToProps(state) {
    return {
      userInfo: CommonUtils.getInvitedTokenInfo(state),
      userList: state.Dashboard.userInfo,
      summeryUserList: state.Dashboard.summeryUserList,
      invitedUserInfo: state.Dashboard.invitedUserInfo,
      inviteTokenInfo: state.InvitationHandler.accessInfo,
    };
  }

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

InvitationHandler.defaultProps = {
    inviteInfo: { Error: "No data recieved" },
    currentUserInfo: { Error: "No data recieved" }
};

export default withRouter(
    connect(mapStateToProps, matchDispatchToProps)(InvitationHandler)
);